import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import { GetTransactionsParams, TransactionFilterDto, TransactionsList } from '../types/transaction';

export const transactionsAPI = createApi({
    reducerPath: 'transactionsAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    tagTypes: ['Transaction'],
    endpoints: (builder) => ({
        getAllTransactions: builder.query<TransactionsList, GetTransactionsParams>({
            query: ({ page, pageSize, orderBy, searchTerm, filters, clientId }) => ({
                url: 'Transactions',
                method: 'GET',
                params: {
                    page,
                    pageSize,
                    orderBy,
                    searchTerm,
                    filters: JSON.stringify(filters),
                    clientId
                }
            }),
            providesTags: [{ type: 'Transaction', id: 'LIST' }]
        }),
        exportTransactionsCsv: builder.query<Blob, { clientId: number; orderBy?: string; searchTerm?: string; filters?: TransactionFilterDto }>({
            query: ({ clientId, orderBy, searchTerm, filters }) => ({
                url: 'Transactions/export',
                method: 'GET',
                params: {
                    clientId,
                    orderBy,
                    searchTerm,
                    filters: filters ? JSON.stringify(filters) : undefined
                },
                responseType: 'blob'
            })
        }),
        exportUnknownItemsCsv: builder.query<Blob, { clientId: number; orderBy?: string; searchTerm?: string; filters?: Record<string, unknown> }>({
            query: ({ clientId, orderBy, searchTerm, filters }) => ({
                url: 'Transactions/UnknownItems/export',
                method: 'GET',
                params: {
                    clientId,
                    orderBy,
                    searchTerm,
                    filters: filters ? JSON.stringify(filters) : undefined
                },
                responseType: 'blob'
            })
        }),
    }),
});

export const {
    useLazyGetAllTransactionsQuery,
    useLazyExportTransactionsCsvQuery,
    useLazyExportUnknownItemsCsvQuery,
} = transactionsAPI;